// convenience functions to access URL parameters
import { useParams } from "react-router-dom";

export function useCurrentDatabaseId() {
  return useParams<"databaseId">();
}

export function useCurrentProjectId() {
  return useParams<"databaseId" | "projectId">();
}

export function useCurrentInventoryId() {
  return useParams<"databaseId" | "inventoryId">();
}

export function useCurrentObjectId() {
  return useParams<"databaseId" | "inventoryId" | "objectId">();
}

export function useCurrentInventoryFormId() {
  return useParams<"databaseId" | "inventoryId" | "formId">();
}

export function useCurrentInventoryFormFieldId() {
  return useParams<"databaseId" | "inventoryId" | "formId" | "field">();
}
